import { apiUrl } from "../config/api";

export async function refreshToken(currentToken) {
  let url = apiUrl('RefreshToken')

  return sendReq(currentToken, url);
}

async function sendReq(currentToken, url) {
  let res = await fetch(url, {
    method: "POST",
    headers: { Authorization: `Bearer ${currentToken}` },
  });
  return res.json();
}
